export default __webpack_public_path__ + "static/media/boat.bg.fd5a42ac.svg";